"use strict";

exports.__esModule = true;
exports.propEntryMaker = void 0;
var _errors = require("../../common/errors");
var _config = require("../../entities/config");
var _record = require("../../entities/record");
var _schema = require("../../entities/schema");
var _value = require("../../entities/value");
const propEntryMaker = getValueEntry => ({
  schema,
  schemas,
  currentRecord,
  connection
}, dependencies) => {
  if (currentRecord) {
    const valueData = getValueData({
      schema,
      currentRecord,
      schemas,
      connection
    }, dependencies);
    if (shouldSetValue(dependencies.config, valueData.value)) {
      return getValueEntry({
        valueData,
        connection
      }, dependencies);
    }
  }
  return undefined;
};
exports.propEntryMaker = propEntryMaker;
const getValueData = ({
  schema,
  currentRecord,
  schemas,
  connection: {
    expression,
    fieldKey
  }
}, dependencies) => expression ? evaluateExpression({
  expression,
  schema,
  currentRecord
}, dependencies) : getFieldData({
  fieldKey,
  schema,
  schemas,
  currentRecord
}, dependencies);
const shouldSetValue = (config, value) => !(_config.Config.isLivePreviewEnabled(config) && _value.Value.isEmpty(value));
const evaluateExpression = ({
  expression,
  schema,
  currentRecord
}, {
  dataExpression,
  errorReporter
}) => {
  try {
    const {
      value,
      type
    } = dataExpression.evaluate({
      expression,
      variables: populateEmptyBooleanFields(currentRecord, schema)
    });
    return {
      value,
      type,
      fieldType: undefined
    };
  } catch (error) {
    errorReporter.report(_errors.CoreError.of('Failed to evaluate expression', {
      cause: error
    }));
    return {
      value: '',
      type: undefined,
      fieldType: undefined
    };
  }
};
const getFieldData = ({
  currentRecord,
  fieldKey: fieldPath,
  schema,
  schemas
}, {
  errorReporter
}) => {
  const [fieldKey, referencedFieldKey] = fieldPath.split('.');
  if (referencedFieldKey) {
    const referencedCollectionId = _schema.Schema.getReferencedCollectionId(schema, fieldKey);
    const referencedSchema = referencedCollectionId && schemas.find(({
      id
    }) => id === referencedCollectionId);
    if (!referencedSchema) {
      errorReporter.report(_errors.CoreError.of('Referenced schema not found'));
    }
    const referencedFieldType = withErrorReporting(() => _schema.Schema.getReferencedFieldType(schema, schemas, {
      fieldKey,
      referencedFieldKey
    }), errorReporter);
    return {
      value: _record.Record.getValue(currentRecord[fieldKey] ?? {}, referencedFieldKey),
      fieldType: referencedFieldType
    };
  }
  return {
    value: _record.Record.getValue(currentRecord, fieldKey),
    fieldType: _schema.Schema.getFieldType(schema, fieldKey)
  };
};
const withErrorReporting = (fn, errorReporter) => {
  try {
    return fn();
  } catch (error) {
    errorReporter.report(error);
  }
};
const populateEmptyBooleanFields = (record, schema) => {
  const updatedRecord = {};
  for (const [fieldKey, value] of Object.entries(record)) {
    updatedRecord[fieldKey] = _schema.Schema.isFieldOfType(schema, fieldKey, 'boolean') && _value.Value.isEmpty(value) ? false : value;
  }
  return updatedRecord;
};
//# sourceMappingURL=prop-entry-maker.js.map